export interface IZoneForm {
    projectId: number;
    locationId: number;
}

export class ZoneFormValue implements IZoneForm {
    
    projectId: number = -1;
    locationId: number = -1;
    constructor(init?: ZoneFormValue) {
        Object.assign(this, init);
    }
}

export class ZoneError {
    projectId: boolean = false;
    locationId:boolean = false;
}